import { render, staticRenderFns } from "./ShopIntegrationConfirmation.vue?vue&type=template&id=2bb8f481&scoped=true&"
import script from "./ShopIntegrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ShopIntegrationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ShopIntegrationConfirmation.vue?vue&type=style&index=0&id=2bb8f481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8f481",
  null
  
)

export default component.exports